import React, { ChangeEvent } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { cn } from 'shared/lib';

interface UploadButtonProps {
  onImageUpload: (url: string) => void;
  onVideoUpload: (url: string) => void;
  inputId?: string;
  className?: string;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  onImageUpload,
  onVideoUpload,
  inputId = 'upload-media',
  className
}) => {
  const handleUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isImage = file?.type?.startsWith('image/');
    const isVideo = file?.type?.startsWith('video/');

    if (isImage) {
      const url = await uploadImage(file);
      onImageUpload(url);
    } else if (isVideo) {
      const url = await uploadVideo(file);
      onVideoUpload(url);
    } else {
      alert('Unsupported file type');
    }

    e.target.value = '';
  };

  return (
    <label htmlFor={inputId} className={cn('ag-cursor-pointer', className)}>
      <BsFillPlusCircleFill size={32} />
      <input
        type="file"
        id={inputId}
        accept="image/*,video/*"
        onChange={handleUpload}
        className="ag-hidden"
      />
    </label>
  );
};

const uploadImage = async (file: File): Promise<string> => {
  return URL.createObjectURL(file);
};

const uploadVideo = async (file: File): Promise<string> => {
  return URL.createObjectURL(file);
};
